import { Box, IconButton, Typography } from '@material-ui/core'
import { ERROR_COLORS, INFO_COLORS, SUCCESS_COLORS } from 'asterX-UI'
import { AsterChip } from 'asterX-UI/Chip'
import { FileIcon } from 'asterX-UI/Icons/FileIcon'
import { CollectionService } from 'lib/api/services/collection.service'
import { debounce } from 'lodash'

const CompletedSubscriber = 'Завершено абонентом'
const CompletedRemote = 'Завершено удаленной стороной'
const CallRejected = 'Вызов отклонен'
const CallCanceled = 'Вызов отменен'

export const callHistoryColumns = [
  'Дата и время звонка',
  'Номер телефона',
  'Менеджер',
  'Статус звонка',
  'Продолжительность звонка',
  'Запись звонка'
]

const getCallStatusColor = code => {
  const colors = {
    [CompletedSubscriber]: {
      backgroundColor: SUCCESS_COLORS[50],
      color: SUCCESS_COLORS[700],
      border: `1px solid ${SUCCESS_COLORS[200]}`
    },
    [CompletedRemote]: {
      backgroundColor: SUCCESS_COLORS[50],
      color: SUCCESS_COLORS[700],
      border: `1px solid ${SUCCESS_COLORS[200]}`
    },
    [CallRejected]: {
      backgroundColor: ERROR_COLORS[50],
      color: ERROR_COLORS[700],
      border: `1px solid ${ERROR_COLORS[200]}`
    },
    [CallCanceled]: {
      backgroundColor: ERROR_COLORS[50],
      color: ERROR_COLORS[700],
      border: `1px solid ${ERROR_COLORS[200]}`
    }
  }

  return colors?.[code] || {}
}

export const callHistoryRows = list => {
  if (!list) {
    return []
  }

  const handleClickAudio = debounce(async item => {
    try {
      const res = await CollectionService.getCallAudio(item.callId)

      const blob = new Blob([res.data], { type: 'audio/mpeg' })
      const url = window.URL.createObjectURL(blob)

      window.open(url, '_blank')

      setTimeout(() => {
        window.URL.revokeObjectURL(url)
      }, 100)
    } catch (error) {
      console.error('Ошибка при загрузке файла mp3', error)
    }
  }, 300)

  return list.map(item => {
    return [
      item?.ringDate || '-',
      item?.clientPhoneNumber?.toString()?.toPhone() || '-',
      item?.createdByFullName || '-',
      <AsterChip label={item?.status} style={getCallStatusColor(item?.status)} />,
      item?.ringDuration,
      <IconButton
        item
        style={{ position: 'relative', cursor: 'pointer', padding: 0 }}
        onClick={() => handleClickAudio(item)}
      >
        <FileIcon />
        <Box
          style={{
            position: 'absolute',
            top: '15px',
            left: '-8px',
            border: `1px solid ${INFO_COLORS[500]}`,
            backgroundColor: INFO_COLORS[500],
            borderRadius: 2,
            padding: '0 4px'
          }}
        >
          <Typography
            style={{
              fontSize: 10,
              fontWeight: 700,
              color: '#FFFFFF'
            }}
          >
            MP3
          </Typography>
        </Box>
      </IconButton>
    ]
  })
}
